import React, { useState, useEffect, useMemo } from 'react';
import { parse, stringify } from '../../util/urlHelpers';
import css from './ManageStockPage.css';

const KeywordsFilter = ({ location, history }) => {
  const queryParams = useMemo(() => parse(location.search), [location.search]);
  const urlKeywords = queryParams.keywords || '';

  const [inputValue, setInputValue] = useState(urlKeywords);

  useEffect(() => {
    setInputValue(urlKeywords);
  }, [urlKeywords]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputValue !== urlKeywords) {
        const newQueryParams = {
          ...queryParams,
          keywords: inputValue.trim() ? inputValue.trim() : undefined,
        };

        if (!newQueryParams.keywords) delete newQueryParams.keywords;

        history.push({
          pathname: location.pathname,
          search: stringify(newQueryParams),
        });
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [inputValue, urlKeywords, queryParams, history, location.pathname]);

  return (
    <div className={css.filterColumnWrapper}>
      <label htmlFor="keywordSearchInput" className={css.filterLabel}>
        Szukaj produktu:
      </label>
      <div className={css.searchFilterWrapper}>
        <input
          id="keywordSearchInput"
          type="text"
          placeholder="Szukaj po nazwie..."
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className={css.searchInput}
        />
        {inputValue && (
          <button 
            type="button"
            onClick={() => setInputValue('')} 
            className={css.clearSearchBtn}
            title="Wyczyść szukanie"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
};

export default KeywordsFilter;